// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2v8Ro","title":"Header_title__d30xI","side":"Header_side__2TWpu"};